import React from 'react';
import {JsonAdSummary} from '../../ext/lib/types';
import {APIError, UnsafeAPIResponse} from '../../hooks/useApi';
import {User} from '../common/UserContext';
import {pathEq} from 'ramda';
import ApproveAdActions from './ApproveAdActions';
import adSummaryList from './AdSummaryList';
import useApi from '../../hooks/useApi';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ApproveAdsList: React.FC<any> = adSummaryList(ApproveAdActions);

const ApproveAds: React.FC<{user: User; apiToken: string}> = ({user, apiToken}) => {
  const unsafeAds: UnsafeAPIResponse<JsonAdSummary[]> = useApi(apiToken, '/api/v1/requests/approve');
  if (pathEq(['@@type'], 'Error', unsafeAds)) {
    console.error((unsafeAds as APIError).message);
    return <div className="alert error">An error occurred while fetching ads. Try again or contact support</div>;
  } else {
    return <ApproveAdsList
      user={user}
      ads={unsafeAds}
      emptyMessage="All ads have been approved."
      flagUnpaid={true}
    />;
  }
};
export default ApproveAds;
